export interface DeviceInfo {
  deviceModel?: string;
  deviceOs?: string;
  deviceOsVersion?: string;
  browser?: string;
  appVersion?: string;
}

export function getDeviceInfo(): DeviceInfo {
  const ua = navigator.userAgent;
  const info: DeviceInfo = {};

  // Определяем модель устройства
  if (/Macintosh/.test(ua)) {
    info.deviceModel = 'Macintosh';
  } else if (/iPhone/.test(ua)) {
    const match = ua.match(/iPhone\s+(\d+)/);
    info.deviceModel = match ? `iPhone ${match[1]}` : 'iPhone';
  } else if (/iPad/.test(ua)) {
    info.deviceModel = 'iPad';
  } else if (/Android/.test(ua)) {
    const match = ua.match(/Android.*;\s([^)]+)\)/);
    info.deviceModel = match ? match[1].trim() : 'Android Device';
  } else if (/Windows/.test(ua)) {
    info.deviceModel = 'Windows PC';
  }

  // Определяем ОС
  if (/Mac OS X/.test(ua)) {
    info.deviceOs = 'Intel Mac OS';
    const match = ua.match(/Mac OS X\s+(\d+)[._](\d+)[._]?(\d+)?/);
    if (match) {
      info.deviceOsVersion = `${match[1]}.${match[2]}.${match[3] || '0'}`;
    }
  } else if (/iPhone OS|iOS/.test(ua)) {
    info.deviceOs = 'iOS';
    const match = ua.match(/OS\s+(\d+)[._](\d+)[._]?(\d+)?/);
    if (match) {
      info.deviceOsVersion = `${match[1]}.${match[2]}.${match[3] || '0'}`;
    }
  } else if (/Android/.test(ua)) {
    info.deviceOs = 'Android';
    const match = ua.match(/Android\s+(\d+)[._](\d+)[._]?(\d+)?/);
    if (match) {
      info.deviceOsVersion = `${match[1]}.${match[2]}.${match[3] || '0'}`;
    }
  } else if (/Windows NT/.test(ua)) {
    info.deviceOs = 'Windows';
    const match = ua.match(/Windows NT\s+(\d+)[._](\d+)/);
    if (match) {
      const version = match[1] + '.' + match[2];
      let osVersion: string;
      switch (version) {
        case '10.0':
          osVersion = '10';
          break;
        case '6.3':
          osVersion = '8.1';
          break;
        case '6.2':
          osVersion = '8';
          break;
        case '6.1':
          osVersion = '7';
          break;
        default:
          osVersion = version;
      }
      info.deviceOsVersion = osVersion;
    }
  }

  // Определяем браузер
  if (/Chrome/.test(ua) && !/Edg/.test(ua)) {
    info.browser = 'Chrome';
  } else if (/Edg/.test(ua)) {
    info.browser = 'Edge';
  } else if (/Firefox/.test(ua)) {
    info.browser = 'Firefox';
  } else if (/Safari/.test(ua) && !/Chrome/.test(ua)) {
    info.browser = 'Safari';
  } else if (/Opera|OPR/.test(ua)) {
    info.browser = 'Opera';
  }

  // Версия приложения (если есть в localStorage)
  const appVersion = localStorage.getItem('appVersion');
  if (appVersion) {
    info.appVersion = appVersion;
  }

  return info;
}

